import {
    Bars3Icon,
    CalendarIcon,
    HomeIcon,
    ArrowUpIcon,
    ArrowUpOnSquareIcon,
    MagnifyingGlassCircleIcon,
    MapIcon,
    MegaphoneIcon,
    UserGroupIcon,
    XMarkIcon,
    InboxIcon,
    UsersIcon,
    CogIcon,
    DocumentIcon,
    QuestionMarkCircleIcon,
    ArrowLeftOnRectangleIcon,
    ArrowDownTrayIcon,
    EnvelopeIcon,
    BellIcon,
    EnvelopeOpenIcon, MagnifyingGlassIcon, Bars3BottomLeftIcon, BookOpenIcon, ClipboardDocumentIcon, CloudIcon, ShoppingCartIcon, ShoppingBagIcon, FolderIcon, GlobeAltIcon, UserCircleIcon, CheckCircleIcon
} from '@heroicons/vue/24/outline';

export default [
    { name: 'Dashboard', href: '/dashboard', icon: HomeIcon, current: false, order: 0 },
    { name: 'Aufgaben', href: '/dashboard/Aufgaben', icon: CheckCircleIcon, current: false, order: 1 },
    { name: 'Posteingang', href: '/dashboard/Posteingang', icon: InboxIcon, current: false, order: 2 },
    { name: 'Vorprojekt', href: '/dashboard/Vorprojekt', icon: FolderIcon, current: false, order: 3 },
    { name: 'Kontakte', href: '/dashboard/Kontakte', icon: UserCircleIcon, current: false, order: 4 },
    { name: 'Teams', href: '/dashboard/Teams', icon: UsersIcon, current: false, order: 5 },
    { name: 'Website', href: '/dashboard/Website', icon: GlobeAltIcon, current: false, order: 6 },
    { name: 'Blog', href: '/dashboard/Blog', icon: DocumentIcon, current: false, order: 7 },
    { name: 'Settings', href: '/dashboard/Settings', icon: CogIcon, current: false, order: 8 }
]
;